import * as Outpost from '@peaky-ai/outpost-browser';
import { setNonce } from 'get-nonce';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App';
import { config } from './lib/config';
import './index.css';

/*
 * The dashboard reports its own errors to itself.
 *
 * Dogfooding is the point: if the ingest path breaks, the team that maintains
 * it is the first to notice.
 */
Outpost.init({
  dsn: config.dsn,
  environment: import.meta.env.MODE,
  release: __APP_VERSION__,
  // The dashboard talks to its own API constantly; recording every call as a
  // breadcrumb would drown the useful ones.
  captureFetch: false,
  ignoreErrors: ['ResizeObserver loop limit exceeded'],
});

/*
 * The style nonce serve.ts minted for this page. Radix's scroll lock creates a
 * <style> element when a dialog, menu or select opens, and get-nonce is where
 * it looks for a nonce; without one the Content-Security-Policy refuses it.
 * Read from the property: browsers hide the attribute once the page has loaded.
 */
const nonce = document.querySelector<HTMLMetaElement>('meta[property="csp-nonce"]')?.nonce;
if (nonce) {
  setNonce(nonce);
}

const container = document.getElementById('root');
if (!container) {
  throw new Error('Outpost: #root element is missing from index.html');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
